/**
 * Central SEO configuration.
 *
 * Every page-level title, description, canonical URL and social card is derived
 * from these values, so the site only has one place to change branding.
 */

export const siteUrl = "https://hollas.net"
export const siteName = "Hollas.net"
export const siteTitle = "Hollas.net — Digital Transformation, AI & Security"
export const siteDescription =
  "Hollas.net specializes in digital transformation, AI implementation, and innovative technology solutions for businesses looking to grow and evolve."
export const defaultOgImage = "/images/og-image.jpg"
export const twitterHandle = ""

/** Resolve a path or URL to an absolute URL on this site. */
export function absoluteUrl(path: string = "/"): string {
  if (/^https?:\/\//i.test(path)) return path
  return new URL(path, siteUrl).toString()
}

/**
 * Canonical URL for a page: absolute, query/hash stripped, no trailing slash
 * (except the root) so that `/about`, `/about/` and `/about?utm=x` do not get
 * indexed as three separate pages.
 */
export function canonicalUrl(pathname: string): string {
  const path = pathname.replace(/\/+$/, "") || "/"
  return absoluteUrl(path)
}

/**
 * Serialize JSON-LD for injection via `{@html}`. Escaping `<` prevents a value
 * containing `</script>` from breaking out of the script tag.
 */
export function jsonLdScript(schema: object): string {
  return JSON.stringify(schema).replace(/</g, "\\u003c")
}

/** Organization schema, reused across pages that describe the business. */
export const organizationSchema = {
  "@type": "Organization",
  "@id": `${siteUrl}/#organization`,
  name: siteName,
  url: siteUrl,
  logo: absoluteUrl("/images/hollas-logo.svg"),
  description: siteDescription,
}

/** Peter Hollas — referenced by the CV page and as the site's author. */
export const personSchema = {
  "@type": "Person",
  "@id": `${siteUrl}/#peter-hollas`,
  name: "Peter Liam Hollas",
  url: absoluteUrl("/about"),
  image: absoluteUrl("/images/selfie.jpg"),
  jobTitle: "Technology Leader, Architect & Innovator",
  worksFor: { "@id": `${siteUrl}/#organization` },
}
